import React, { useEffect, useRef } from 'react';
import { motion } from 'framer-motion';
import { SparklesIcon } from '@heroicons/react/24/solid';

export const ACCOUNT_SETUP_TOTAL_MS = 1200;

export default function AccountSetupLoading({
  onComplete,
  waiting = false,
  skipIntro = false,
  holdUntilReady = false,
  firstName,
}) {
  const onCompleteCalledRef = useRef(false);

  const safeOnComplete = () => {
    if (onCompleteCalledRef.current) return;
    onCompleteCalledRef.current = true;
    onComplete?.();
  };

  useEffect(() => {
    if (waiting || holdUntilReady) return;
    const t = setTimeout(safeOnComplete, ACCOUNT_SETUP_TOTAL_MS);
    return () => clearTimeout(t);
  }, [waiting, holdUntilReady]);

  const greeting = firstName ? `Welcome, ${firstName}.` : 'Welcome.';

  return (
    <div
      className="admin-theme fixed inset-0 flex flex-col items-center justify-center z-50"
      role="status"
      aria-live="polite"
      aria-label={greeting}
      style={{
        fontFamily: '"Inter", sans-serif',
        backgroundColor: 'var(--admin-bg-primary)',
      }}
    >
      <motion.div
        initial={skipIntro ? false : { opacity: 0, scale: 0.96 }}
        animate={{ opacity: 1, scale: 1 }}
        transition={{ duration: 0.35 }}
        className="flex flex-col items-center gap-4 px-6 text-center"
      >
        <motion.div
          initial={{ scale: 0, rotate: -45 }}
          animate={{ scale: 1, rotate: 0 }}
          transition={{ type: 'spring', stiffness: 360, damping: 22, delay: 0.1 }}
          className="w-14 h-14 rounded-full flex items-center justify-center"
          style={{ background: 'var(--admin-accent-light)' }}
        >
          <SparklesIcon className="w-7 h-7 text-[var(--admin-accent)]" />
        </motion.div>
        <h1 className="text-2xl font-semibold gch-text-primary tracking-tight">
          {greeting}
        </h1>
        <p className="text-sm gch-text-secondary max-w-xs">
          Let's get your first game started.
        </p>
      </motion.div>
    </div>
  );
}
